<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>考勤异常申诉</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">考勤异常申诉</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="任务编号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.jobNo"
                    placeholder="请输入任务编号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申诉姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入申诉姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="申诉手机号">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.phone"
                    placeholder="请输入申诉手机号"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                  >
                    <el-option label="待审核" value="0"></el-option>
                    <el-option label="审核通过" value="1"></el-option>
                    <el-option label="审核拒绝" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <TableScrollSlider :table-ref="$refs.multipleTable" />
      <div class="pageTab">
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          ref="multipleTable"
        >
          <!-- <el-table-column type="selection" width="55" align="center">
          </el-table-column> -->
          <el-table-column
            prop="appealNo"
            label="编号"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column prop="appealName" label="申诉人" align="center">
          </el-table-column>
          <el-table-column label="任务名称" align="center" width="180">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.jobTitle }}
                <div slot="reference" class="name-wrapper">
                  <div class="omit">{{ scope.row.jobTitle }}</div>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="考勤日期" align="center" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.startDate }}</div>
              <div>{{ scope.row.endDate }}</div>
            </template>
          </el-table-column>
          <el-table-column label="打卡时间" align="center" width="100">
            <template slot-scope="scope">
              <div>{{ scope.row.startTime }}</div>
              <div>{{ scope.row.endTime }}</div>
            </template>
          </el-table-column>
          <el-table-column label="打卡状态" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.signStatus == 0">未打卡</span>
              <span v-if="scope.row.signStatus == 1">正常打卡</span>
              <span v-if="scope.row.signStatus == -1">迟到打卡</span>
              <span v-if="scope.row.signStatus == -2">早退打卡</span>
              <span v-if="scope.row.signStatus == -3">旷工</span>
            </template>
          </el-table-column>
          <el-table-column label="审核人" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.operatorName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <span class="blueColor" v-if="scope.row.operateStatus == 0"
                >待审核</span
              >
              <span class="greenColor" v-if="scope.row.operateStatus == 1"
                >审核通过</span
              >
              <span class="redColor" v-if="scope.row.operateStatus == 2"
                >审核拒绝</span
              >
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" width="190">
            <template slot-scope="scope">
              <span>{{ scope.row.gmtCreate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理时间" align="center" width="190">
            <template slot-scope="scope">
              <span>{{ scope.row.operateAt }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="160"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="goDetail(scope.row)">详情</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      ruleForm: {
        name: "",
        phone: "",
        status: "",
        jobNo: "",
      },
      tableData: [],
      multipleTable: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.phone = "";
      this.ruleForm.status = "";
      this.ruleForm.jobNo = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    goDetail(val) {
      window.open(
        this.$router.resolve({
          path: "/appealDetail",
          query: {
            id: val.id,
          },
        }).href,
        "_blank"
      );
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        operateStatus: this.ruleForm.status,
        jobNo: this.ruleForm.jobNo,
        appealName: this.ruleForm.name,
        appealPhone: this.ruleForm.phone,
      };
      this.$axios
        .post(`/admapi/sign/appealList`, param)
        .then(({ data }) => {
          let arr = data.items;
          for (var i = 0; i < arr.length; i++) {
            let arr1 = [];
            let arr2 = [];
            if (arr[i].dueAtIn) {
              arr1 = arr[i].dueAtIn.split(" ");
            }
            if (arr[i].dueAtOut) {
              arr2 = arr[i].dueAtOut.split(" ");
            }
            arr[i].startDate = arr1[0] || "";
            arr[i].endDate = arr2[0] || "";
            arr[i].startTime = arr1[1] || "";
            arr[i].endTime = arr2[1] || "";
          }
          this.tableData = arr;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
